import { NavMarker } from 'react-rhumb';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { View } from 'foundations-components/components/View';
import ACMissingContentError from 'academy-common-lib/components/error/ACMissingContentError';
import LessonInfoTabs from '../LessonPage/LessonInfoTabs';
import StoredContentContainer from '../../containers/StoredContentContainer';
import TrackContentWithInteractiveEducation from './TrackContentWithInteractiveEducation';
import { PRE_ASSESSMENT_URL_FRAGMENT, SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../constants/Navigation.legacy';
import { SCREENS } from '../../constants/Tracking.migrated';
import { useLessonQuizMeSection } from '../../features/interactiveEducation/hooks/useLessonQuizMeSection';
import { LessonPreQuizAlert } from '../../features/preAssessmentQuiz/components/LessonPreQuizAlert';
import { LessonPreQuizContainer } from '../../features/preAssessmentQuiz/components/LessonPreQuizContainer';
import { usePlaylistIdFromSearch } from '../../features/playlistContent/hooks.migrated';
import { OptionalToolRecommendationSection } from '../../features/toolRecommendations/index.migrated';
import { getNextContentUrl } from '../../features/tracks/tracksRouting';
import { isVideoAsset } from '../../features/tracks/tracksUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackPage = ({
  track,
  trackProgress,
  onAdvanceContent,
  onSkipPreAssessment,
  onStartLessonWithPreAssessmentFocus,
  lesson,
  lessonProgress,
  content,
  contentFragment,
  contentProgress
}) => {
  var _lesson$useCases;
  const navigate = useACNavigate();
  const isInPlaylist = !!usePlaylistIdFromSearch();
  const {
    lessonQuizProps,
    preAssessmentAvailable,
    retryQuizGeneration
  } = useLessonQuizMeSection({
    lesson
  });
  const handlePreAssessmentClick = () => lesson && navigate(`/tracks/${track.id}/${lesson.id}/${PRE_ASSESSMENT_URL_FRAGMENT}`);
  const nextContentUrl = lesson ? getNextContentUrl({
    track,
    lesson,
    contentId: lesson.content[lesson.content.length - 1].id,
    isInPlaylist
  }) : undefined;
  const sectionViewProps = {
    backgroundColor: 'fill-surface-default',
    borderColor: 'border-core-subtle',
    borderRadius: '300',
    borderStyle: 'solid',
    borderWidth: '100',
    overflow: 'hidden'
  };
  if (lesson && contentFragment === PRE_ASSESSMENT_URL_FRAGMENT) return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
      children: /*#__PURE__*/_jsx(LessonPreQuizContainer, {
        lesson: lesson,
        onRetry: retryQuizGeneration,
        onSkip: onSkipPreAssessment,
        onStartLessonWithPreAssessmentFocus: onStartLessonWithPreAssessmentFocus,
        screen: SCREENS.TRACK,
        track: track
      })
    })), /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(LessonInfoTabs, {
        content: content,
        hubId: track.hubId,
        lesson: lesson
      })
    }))]
  });
  if (contentFragment === SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS && lesson) return /*#__PURE__*/_jsxs(_Fragment, {
    children: [preAssessmentAvailable && /*#__PURE__*/_jsx(LessonPreQuizAlert, {
      lesson: lesson,
      onClick: handlePreAssessmentClick,
      screen: SCREENS.TRACK,
      track: track
    }), /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
      children: /*#__PURE__*/_jsx(OptionalToolRecommendationSection, {
        contentLanguage: lesson.language ? readUnhandledEnumCase(lesson.language) : undefined,
        contentName: lesson.name,
        nextContentUrl: nextContentUrl,
        useCases: (_lesson$useCases = lesson.useCases) === null || _lesson$useCases === void 0 ? void 0 : _lesson$useCases.map(readUnhandledEnumCase)
      })
    })), /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsx(LessonInfoTabs, {
        hubId: track.hubId,
        lesson: lesson
      })
    }))]
  });
  if (lesson && content && isVideoAsset(content)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [preAssessmentAvailable && /*#__PURE__*/_jsx(LessonPreQuizAlert, {
        lesson: lesson,
        onClick: handlePreAssessmentClick,
        screen: SCREENS.TRACK,
        track: track
      }), /*#__PURE__*/_jsx(TrackContentWithInteractiveEducation, {
        lesson: lesson,
        lessonQuizProps: lessonQuizProps,
        onAdvanceContent: onAdvanceContent,
        track: track,
        videoContent: content
      }, content.id), /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(LessonInfoTabs, {
          content: content,
          hubId: track.hubId,
          lesson: lesson
        })
      }))]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [preAssessmentAvailable && /*#__PURE__*/_jsx(LessonPreQuizAlert, {
      lesson: lesson,
      onClick: handlePreAssessmentClick,
      screen: SCREENS.TRACK,
      track: track
    }), content ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        children: /*#__PURE__*/_jsx(StoredContentContainer, {
          content: content,
          contentProgress: contentProgress,
          lesson: lesson,
          lessonProgress: lessonProgress,
          onFinish: onAdvanceContent,
          track: track,
          trackProgress: trackProgress
        })
      })), lesson && /*#__PURE__*/_jsx(View, Object.assign({}, sectionViewProps, {
        marginBlockStart: "600",
        children: /*#__PURE__*/_jsx(LessonInfoTabs, {
          content: content,
          hubId: track.hubId,
          lesson: lesson
        })
      }))]
    }) : /*#__PURE__*/_jsx(NavMarker, {
      name: "COURSE_VIEW_CONTENT_MISSING_ERROR",
      children: /*#__PURE__*/_jsx(ACMissingContentError, {})
    })]
  });
};
export default TrackPage;